'use strict';

module.exports = ['$rootScope', '$scope', '$timeout', '$window', 'UserProfileSvc', function ($rootScope, $scope, $timeout, $window, UserProfileSvc) {

    // ------------------
    // $RootScope functions
    // ------------------
    if (angular.isDefined($rootScope.user_id)) {
        UserProfileSvc.get($rootScope.user_id).then(function (data) {
            $rootScope.user_profile = data;
        });
    }

    $rootScope.$on('user-profile-updated', function (event, data) {
        $rootScope.user_profile = data;
    });

    $rootScope.$on('user-profile-plant-settings-updated', function (event, data) {
        var index = Array.findObjectIndex($rootScope.user_profile.plant_settings, 'plant', parseInt($rootScope.plant));
        if (index != -1) {
            $rootScope.user_profile.plant_settings[index] = data;
        } else {
            $rootScope.user_profile.plant_settings.push(data);
        }
    });

    $rootScope.applyResize = function(){
        $rootScope.isMobile = ($window.matchMedia('(max-width: 767px)').matches);
        $rootScope.isTablet = ($window.matchMedia('(max-width: 991px)').matches);
    };

    angular.element($window).resize(function () {
        $timeout($rootScope.applyResize);
    });

    $rootScope.applyResize();
}];
